export default "__VITE_ASSET__Dll3hSH9__"